module.exports = "https://static.wmbcdn.com/uniweb/images/590d7c27240aba7b763778637e53f364.webp";